import React, { useState, useRef, useEffect } from 'react'
import './Timer.css'

const Countimer = () => {

    // const [counter, setCounter] = useState({
    //     // hour: 0,
    //     // mint: 0,
    //     sec: 1
    // });


    // const Ref = useRef(null);

    // // We need ref in this, because we are dealing
    // // with JS setInterval to keep track of it and
    // // stop it when needed
    // const [timer, setTimer] = useState('00:00:00');


    // const getTimeRemaining = (e) => {
    //     const total = Date.parse(e) - Date.parse(new Date());
    //     const seconds = Math.floor((total / 1000) % 60);
    //     const minutes = Math.floor((total / 1000 / 60) % 60);
    //     const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    //     return {
    //         total, hours, minutes, seconds
    //     };
    // }


    // const startTimer = (e) => {
    //     let { total, hours, minutes, seconds } 
    //                 = getTimeRemaining(e);
    //     if (total >= 0) {

    //         // update the timer
    //         // check if less than 10 then we need to 
    //         // add '0' at the beginning of the variable
    //         setTimer(
    //             (hours > 9 ? hours : '0' + hours) + ':' +
    //             (minutes > 9 ? minutes : '0' + minutes) + ':'
    //             + (seconds > 9 ? seconds : '0' + seconds)
    //         )
    //     }
    // }


    // const clearTimer = (e) => {

    //     // If you adjust it you should also need to
    //     // adjust the Endtime formula we are about
    //     // to code next    
    //     setTimer('00:00:20');

    //     // If you try to remove this line the 
    //     // updating of timer Variable will be
    //     // after 1000ms or 1sec
    //     if (Ref.current) clearInterval(Ref.current);
    //     const id = setInterval(() => {
    //         startTimer(e);
    //     }, 1000)
    //     Ref.current = id;
    // }

    // const getDeadTime = () => {
    //     let deadline = new Date();

    //     // This is where you need to adjust if 
    //     // you entend to add more time
    //     deadline.setSeconds(deadline.getSeconds() + 10);
    //     return deadline;
    // }

    // // We can use useEffect so that when the component
    // // mount the timer will start as soon as possible

    // // We put empty array to act as componentDid
    // // mount only
    // useEffect(() => {
    //     clearTimer(getDeadTime());
    // }, []);

 
    const [counter, setCounter] = useState(0);
    // const onClickReset = () => {
    // //    console.log( counter.sec + 1)   ;

    // setInterval(() => console.log( counter + 1),1000);
    // }
    // counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    useEffect(() => {
        setTimeout(() => setCounter(counter + 1), 1000);
    }, [counter]);
    return (
        <div className="mainTimer">
            {/* <h2>{counter.hour+":"+counter.mint+":"+counter.sec}</h2> */}
            <h2>{counter}</h2>
            {/* <button onClick={onClickReset} className='timerButton'>Start</button> */}
        </div>
    )
}

export default Countimer